export default defineNuxtPlugin(async() => {
    const { getSession } = useAuth();

    // Fetch the session on the client-side to sync with the server
    if (process.client) {
        await getSession();
    }
});
